import CtaIcon from '../ui/CtaIcon';
import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import { PageHeader } from '../ui/PageHeader';
import PageBackLink from '../ui/PageBackLink';
import SettingsSubnav from './SettingsSubnav';
import { SETTINGS_HUB_CARDS } from './settingsNav';

/**
 * Account settings hub. Premium/billing lives here with notifications and privacy.
 */
const SettingsHubPage: React.FC = () => {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <PageBackLink label="Back to Home" to="/" className="mb-4" />
        <PageHeader
          eyebrow="Account"
          title="Settings"
          description="Notifications, Bilt:Spec Premium billing, and privacy controls for your account."
        />
        <SettingsSubnav hideOverview />
        <ul className="mt-2 space-y-3">
          {SETTINGS_HUB_CARDS.map((card) => (
            <li key={card.to}>
              <Link
                to={card.to}
                className="group block rounded-xl border border-white/[0.08] bg-[#0c0c0c] px-4 py-4 sm:px-5 transition-colors duration-200 cursor-pointer hover:border-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm font-medium text-white group-hover:text-orange-100">
                      {card.label}
                    </p>
                    <p className="mt-1 text-sm text-zinc-400">{card.description}</p>
                  </div>
                  <span
                    className="shrink-0 text-zinc-500 group-hover:text-orange-300 transition-colors"
                    aria-hidden
                  >
                    <CtaIcon direction="next" />
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </PageShell>
  );
};

export default SettingsHubPage;
